export default __webpack_public_path__ + "static/media/cover2.398eb5d5.jpg";